"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var I18nPointsFormatClientImpl_1 = __importDefault(require("./I18nPointsFormatClientImpl"));
var I18nPointsFormatClientProvider = /** @class */ (function () {
    function I18nPointsFormatClientProvider() {
        this.CONTEXTUAL_PARAMETERS = ["i18n_pointsformat_locale", "i18n_points_program_name", "i18n_points_style"];
        this.STAGE_VERSION_LABEL_NAME = "AcsI18nPointsFormat";
        this.TABLE_NAME = "acs_I18nPointsFormat";
    }
    I18nPointsFormatClientProvider.prototype.createTypeSafeClient = function (configSet) {
        return new I18nPointsFormatClientImpl_1.default(configSet);
    };
    return I18nPointsFormatClientProvider;
}());
exports.default = I18nPointsFormatClientProvider;
